import { render } from "./StoryComposerElement.vue.js?vue&type=template&id=5bcb5e92!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryComposerElement.vue?vue&type=template&id=5bcb5e92"
import script from "./StoryComposerElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryComposerElement.vue?vue&type=script&lang=js"
export * from "./StoryComposerElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryComposerElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/story-composer/StoryComposerElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bcb5e92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bcb5e92', __exports__)) {
    api.reload('5bcb5e92', __exports__)
  }
  
  module.hot.accept("./StoryComposerElement.vue.js?vue&type=template&id=5bcb5e92!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryComposerElement.vue?vue&type=template&id=5bcb5e92", () => {
    api.rerender('5bcb5e92', render)
  })

}


export default __exports__